module.exports = __webpack_public_path__ + "assets/img/clal1.5766cf66.jpg";